import React from "react";
import { Box, Link } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DownloadIcon from "@iconify/icons-mdi/download";
import PDFIcon from "@iconify/icons-mdi/file-pdf-box-outline";
import showIcon from "@iconify/icons-mdi/show";
import { InlineIcon } from "@iconify/react";

interface OcFileViewerAndDownloaderBoxProps {
  label: string;
  href: string;
  modul: string;
}

export const OcFileViewerAndDownloaderBox = ({
  label,
  href,
  modul,
}: OcFileViewerAndDownloaderBoxProps) => {
  const theme = useTheme();

  const handleShowFile = () => {
    window.open(href, "_blank");
  };

  return (
    <>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        style={{
          height: modul === "cafeteria" ? "56px" : "72px",
          backgroundColor: theme.palette.gray20.main,
          border: `1px solid ${theme.palette.gray40.main}`,
          borderRadius: "8px",
        }}
      >
        <Box width="16px" />
        <InlineIcon icon={PDFIcon} width="24px" />
        <Box width="16px" />
        <Box flexGrow={1}>{label}</Box>
        <Box onClick={handleShowFile}>
          <InlineIcon
            id="showIcon"
            icon={showIcon}
            width="24px"
            style={{
              cursor: "pointer",
            }}
          />
        </Box>
        <Box width="8px" />
        <Link id={label.replaceAll(" ", "_")} href={href} download>
          <Box display="flex">
            <InlineIcon
              icon={DownloadIcon}
              width="24px"
              style={{ color: theme.palette.owGray.main }}
            />
          </Box>
        </Link>
        <Box width="16px" />
      </Box>
    </>
  );
};

export default OcFileViewerAndDownloaderBox;
